/* wrappers-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./wrappers-compiled.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { forwardRef } from 'react';
import ArrowLeft from '@atlaskit/icon/core/migration/arrow-left';
import ArrowRight from '@atlaskit/icon/core/migration/arrow-right';
import { MediaFilmStripListItemSelector } from '.';
import { N20, N40, B400, B50 } from '@atlaskit/theme/colors';
var filmStripViewStyles = null;
var filmStripListWrapperStyles = null;
var filmStripListStyles = null;
var filmStripListItemStyles = null;
var arrowWrapperStyles = null;
var arrowLeftWrapperStyles = null;
var arrowRightWrapperStyles = null;
var shadowStyles = null;
var shadowLeftStyles = null;
var shadowRightStyles = null;
var ShadowLeft = function ShadowLeft(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhk1tuc", "_1ltvidpf"])
  }, children);
};
export var ArrowLeftWrapper = function ArrowLeftWrapper(_ref2) {
  var children = _ref2.children,
    onClick = _ref2.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_2rko1osq _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1rd0 _1e0c1txw _80omtlke _16qsztl5 _syazgpis _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3lyvy _irr3if84 _9h8hln51 _1di61kxl", "_1ltvu2gc _uhasv77o", "arrow"]),
    onClick: onClick,
    style: {
      "--_14yez9t": ix("var(--ds-surface-overlay, ".concat(N20, ")")),
      "--_snhgxu": ix("var(--ds-surface-overlay-hovered, ".concat(N40, ")")),
      "--_1hfkvbo": ix("var(--ds-text-selected, ".concat(B400, ")")),
      "--_rryx0a": ix("var(--ds-background-selected, ".concat(B50, ")"))
    }
  }, children);
};
export var ShadowRight = function ShadowRight(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhk1tuc", "_1xi2idpf"])
  }, children);
};
export var ArrowRightWrapper = function ArrowRightWrapper(_ref4) {
  var children = _ref4.children,
    onClick = _ref4.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: ax(["_2rko1osq _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1rd0 _1e0c1txw _80omtlke _16qsztl5 _syazgpis _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3lyvy _irr3if84 _9h8hln51 _1di61kxl", "_1xi2u2gc _7wy9v77o", "arrow"]),
    onClick: onClick,
    style: {
      "--_14yez9t": ix("var(--ds-surface-overlay, ".concat(N20, ")")),
      "--_snhgxu": ix("var(--ds-surface-overlay-hovered, ".concat(N40, ")")),
      "--_1hfkvbo": ix("var(--ds-text-selected, ".concat(B400, ")")),
      "--_rryx0a": ix("var(--ds-background-selected, ".concat(B50, ")"))
    }
  }, children);
};
export var LeftArrow = function LeftArrow(_ref5) {
  var onClick = _ref5.onClick;
  return /*#__PURE__*/React.createElement(ShadowLeft, null, /*#__PURE__*/React.createElement(ArrowLeftWrapper, {
    onClick: onClick
  }, /*#__PURE__*/React.createElement(ArrowLeft, {
    color: "currentColor",
    spacing: "spacious",
    label: "left"
  })));
};
export var RightArrow = function RightArrow(_ref6) {
  var onClick = _ref6.onClick;
  return /*#__PURE__*/React.createElement(ShadowRight, null, /*#__PURE__*/React.createElement(ArrowRightWrapper, {
    onClick: onClick
  }, /*#__PURE__*/React.createElement(ArrowRight, {
    color: "currentColor",
    spacing: "spacious",
    label: "right"
  })));
};
export var FilmStripViewWrapper = function FilmStripViewWrapper(_ref7) {
  var children = _ref7.children,
    dataTestId = _ref7['data-testid'];
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": dataTestId,
    className: ax(["_2rko1l7b _kqswh2mm _ca0q1ysw _u5f3idpf _n3td1ysw _19bvidpf _1yqxkb7n _1ajs4jg8"])
  }, children);
};
export var FilmStripListWrapper = /*#__PURE__*/forwardRef(function (_ref8, ref) {
  var children = _ref8.children,
    onWheel = _ref8.onWheel,
    onTouchStart = _ref8.onTouchStart,
    onTouchMove = _ref8.onTouchMove,
    onTouchEnd = _ref8.onTouchEnd,
    dataTestId = _ref8['data-testid'];
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    onWheel: onWheel,
    onTouchStart: onTouchStart,
    onTouchMove: onTouchMove,
    onTouchEnd: onTouchEnd,
    "data-testid": dataTestId,
    className: ax(["_1reo15vq _18m915vq _1bsb1kw7 _ca0qv77o _u5f31ysw _n3tdv77o _19bv1ysw"])
  }, children);
});
export var FilmStripList = /*#__PURE__*/React.forwardRef(function (_ref9, ref) {
  var children = _ref9.children,
    style = _ref9.style;
  return /*#__PURE__*/React.createElement("ul", {
    ref: ref
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: style,
    className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _k8m01e03 _6fl41kli _o5721q9c _1e0c1o8l"])
  }, children);
});
export var FilmStripListItem = function FilmStripListItem(_ref10) {
  var children = _ref10.children,
    index = _ref10.index;
  return /*#__PURE__*/React.createElement("li", {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _2mzuglyw _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1e0c1o8l _s7n4nkob _1wybidpf _1lhcidpf", MediaFilmStripListItemSelector]),
    "data-testid": "media-filmstrip-list-item",
    key: index
  }, children);
};